<template>
    <div class="dark:bg-surface-800 border p-4 rounded-lg">
        <h3 class="text-lg font-semibold mb-4">{{ $t('Payment Tax, Discount and VAT') }}</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
                <label class="block text-sm font-medium text-surface-700 mb-2">{{ $t('Payment Tax') }}</label>
                <InputNumber
                    :modelValue="paymentTax"
                    @update:modelValue="$emit('update:paymentTax', $event)"
                    :currency="paymentTaxCoin"
                    :min="0"
                    :step="0.01"
                    :minFractionDigits="2"
                    :maxFractionDigits="2"
                    mode="currency"
                    class="w-full"
                />
            </div>
            <div>
                <label class="block text-sm font-medium text-surface-700 mb-2">{{ $t('VAT Rate') }} (%)</label>
                <InputNumber
                    :modelValue="vatRate"
                    @update:modelValue="$emit('update:vatRate', $event)"
                    suffix="%"
                    :min="0"
                    :max="100"
                    :step="0.1"
                    class="w-full"
                />
            </div>
            <div>
                <label class="block text-sm font-medium text-surface-700 mb-2">{{ $t('Discount') }}</label>
                <InputNumber
                    :modelValue="discount"
                    @update:modelValue="$emit('update:discount', $event)"
                    :currency="discountCoin"
                    :min="0"
                    :step="0.01"
                    :minFractionDigits="2"
                    :maxFractionDigits="2"
                    mode="currency"
                    class="w-full"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    paymentTax: {
        type: Number,
        default: 0
    },
    paymentTaxCoin: {
        type: String,
        default: 'USD'
    },
    vatRate: {
        type: Number,
        default: 0
    },
    discount: {
        type: Number,
        default: 0
    },
    discountCoin: {
        type: String,
        default: 'USD'
    },
    currencies: {
        type: Array,
        default: () => ['USD', 'EUR', 'BRL', 'GBP']
    }
});

defineEmits(['update:paymentTax', 'update:vatRate', 'update:discount', 'update:discountCoin']);
</script>